<script setup lang="ts">
import { computed } from 'vue';
import { RouterView } from 'vue-router';

import { UErrorView, useError } from '@/shared/ui';

const { error } = useError();
const hasError = computed(() => Boolean(error.value?.statusCode));
</script>

<template>
  <div class="main-wrapper">
    <UErrorView v-if="hasError" />
    <RouterView v-else />
  </div>
</template>

<style scoped>
.main-wrapper {
  position: relative;
  flex: 1;
  height: 100%;
}
</style>
